import { render } from "./QuranRukukCard.vue?vue&type=template&id=2ca6e98c"
import script from "./QuranRukukCard.vue?vue&type=script&lang=js"
export * from "./QuranRukukCard.vue?vue&type=script&lang=js"
script.render = render

export default script